<template>
  <div id="catalogue-page" v-if="ready">
    <template>
      <ShowroomBreadcrumbs />
      <ShowroomBanner />
    </template>

    <template>
      <!-- Sidebar ? -->
    </template>

    <template>
      <CatalogRow
        class="products-catalog"
        v-for="(catalog, index) in selectedCatalogs"
        :key="index"
        :id="'catalog-' + catalog.name.toLowerCase()"
        :selectedCatalogs="selectedCatalogs"
        :catalog="catalog"
        :catalogIndex="index"
      />
    </template>

    <DecorationHiddenPlayer v-if="showPlayer" />
  </div>
</template>

<script>
import ShowroomBreadcrumbs from "@/components/Projects/Showrooms/ShowroomBreadcrumbs";
import ShowroomBanner from "@/components/Projects/Showrooms/ShowroomBanner";
//import ShowroomInfoBanner from "@/components/Projects/Showrooms/ShowroomInfoBanner"
import CatalogRow from "@/components/Projects/Showrooms/Catalogue/CatalogRow";

import DecorationHiddenPlayer from "@/components/Projects/Showrooms/DecorationHiddenPlayer";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Catalogue",

  computed: {
    ...mapState("showroom", ["selectedCatalogs", "catalogsData"]),
    ...mapGetters("showroom", ["dealerCode"]),
  },

  methods: {
    ...mapActions("showroom", [
      "checkEmptyCatalogs",
      "setDefaultDecorations",
      "setBreadcrumbs",
      "fetchProductsFromSelectedCatalogs",
      "getDecorationsForSelectedCatalogLayouts",
      "hideCustomizationBox",
    ]),
    ...mapActions("threekit", ["initThreekitColors"]),
    ...mapActions("project", [
      "updateDecorationsForProjectProductsLayouts",
      "redirectToShowroomHome",
    ]),
  },

  async mounted() {
    //validate required fields for this page:
    //  - a dealer

    /*const layouts = this.selectedCatalogs.map((catalog) => {
      return catalog.products.map((product) => {
        return product.threekit_layout
      })
    })[0].filter((v,i,a)=>a.indexOf(v)==i)

    console.log('unique', layouts)*/

    // this.initThreekitColors()
    // this.checkEmptyCatalogs();

    this.hideCustomizationBox();

    if (this.selectedCatalogs?.length) {
      this.ready = true;

      this.setBreadcrumbs([
        { name: "< START", url: `/showrooms/${this.dealerCode}` },
        { name: "MY SHOWROOM", url: `/showrooms/${this.dealerCode}/catalogue` },
      ]);

      //await this.fetchProductsFromSelectedCatalogs();

      if (this.selectedCatalogs?.length) {
        this.getDecorationsForSelectedCatalogLayouts();
        //    this.updateDecorationsForProjectProductsLayouts();
        //this.setDefaultDecorations();
      }

      setTimeout(() => {
        this.showPlayer = true;
        // :)
      }, 2000);
    } else {
      this.redirectToShowroomHome();
    }
  },

  data() {
    return {
      showPlayer: false,
      ready: false,
    };
  },

  components: {
    ShowroomBreadcrumbs,
    ShowroomBanner,
    CatalogRow,
    DecorationHiddenPlayer,
  },
};
</script>